import {defineMessages} from 'react-intl';

const messages = defineMessages({
  placeholder: {
    id: 'GeoFilter.SearchInputPlaceHolder',
    defaultMessage: 'Search by city',
    description: 'GeoFilter: Search Input PlaceHolder',
  },
  curLoc: {
    id: 'GeoFilter.CurrentLocation',
    defaultMessage: 'Current location',
  },
  allLoc: {
    id: 'GeoFilter.AllLocation',
    defaultMessage: 'All Locations',
  },
  findEvents: {
    id: 'GeoFilter.FindEvents',
    defaultMessage: 'Find events near you',
  },
  notIn: {
    id: 'GeoFilter.NotIn',
    defaultMessage: 'Not in',
  },
  addLocation: {
    id: 'GeoFilter.AddLocation',
    defaultMessage: 'Add location',
  },
  updateLocation: {
    id: 'GeoFilter.UpdateLocation',
    defaultMessage: 'Update location',
  },
  loading: {
    id: 'GeoFilter.RetrievingLocation',
    defaultMessage: 'Retrieving location ...',
  },
});

export default messages;
